import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import idleJs from 'idle-js'
import styles from './App.css'
import StatusMessages from '../../components/StatusMessages/StatusMessages'

@CSSModules(styles)
export default class App extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  componentDidMount() {
    new idleJs({
      idle: 1000 * 60 * 60, // idle time in ms
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
      onIdle: function () {
        console.log('Idle, reload page.')
        location.reload()
      }, // callback function to be executed after idle time
      keepTracking: true, // set it to false of you want to track only once
      startAtIdle: false // set it to true if you want to start in the idle state
    }).start()
  }

  render () {
    return (
      <div styleName="app">
        <StatusMessages />
        <img src="/static/img/logo/logo_white.svg" styleName="logo" />
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/App/App.js